import {showAlert, showToast} from "./notifications";
import {reinitQuantityInputs} from "./quantityInput";
import {objectToFormData, formDataToObject} from './utils'

export const initInquiryForm = () => {
    const INQUIRY_FORM_FINAL_STEP = 3;
    const INQUIRY_FORM_STORAGE_KEY = 'inquiry_form_data';
    const inquiryFormContentWrappertEl = document.getElementById('inquiryFormContentWrapper');
    let formEl = null;

    setInquiryIndicator();
    setAddToCartBtn();

    // nacteme formular, pokud jsme na spravne strance
    if (inquiryFormContentWrappertEl) {
        requestForm(true)
    }


    const onSubmit = async (e) => {
        e.preventDefault();
        await requestForm(false);
    }

    const onGoBack = async (e) => {
        e.preventDefault();
        changeStep(formEl, -1);
        await requestForm(false, true);

    }

    const onGoToStep = async (e) => {
        e.preventDefault();
        const linkEl = e.target.closest('.nav-link');
        const {currentStepNumber, maxStepNumber} = getStepInfo(formEl);
        const newStep = linkEl.dataset.step;
        const newStepNumber = getStepNumber(newStep);
        if (currentStepNumber === newStepNumber || newStepNumber > maxStepNumber) {
            return;
        }
        formEl.dataset.currentStep = newStep;
        await requestForm(false, true);
    }

    function setAddToCartBtn() {
        // pridani quantity produktu do poptavky pri kliknuti na tlacitko pridat do poptavky
        document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const productId = btn.dataset.productId;
                const productStep = +btn.dataset.productStep;

                const formData = JSON.parse(localStorage.getItem(INQUIRY_FORM_STORAGE_KEY) ?? "{}");
                const productKey = Object.keys(formData).filter(key =>
                    /^inquiry_form\[items]\[\d+]\[id]$/.test(key)
                ).find(key => formData[key] === productId);

                if (!productKey) return;

                const productIndex = productKey.match(/^inquiry_form\[items]\[(\d+)]\[id]$/)[1];
                const quantityKey = `inquiry_form[items][${productIndex}][quantity]`;
                const quantity = +formData[quantityKey] ?? 0;
                formData[quantityKey] = quantity + productStep;

                localStorage.setItem(INQUIRY_FORM_STORAGE_KEY, JSON.stringify(formData));
            });
        });
    }

    function setInquiryIndicator() {
        const formData = JSON.parse(localStorage.getItem(INQUIRY_FORM_STORAGE_KEY) ?? "{}");

        // secte qutantity vsech produktu v poptavce, pokud to neni nula, zobrazime indikátor
        const hasItems = Object.keys(formData).filter(key =>
            /^inquiry_form\[items]\[\d+]\[quantity]$/.test(key)
        ).reduce((acc, key) => acc + formData[key], 0) > 0;

        document.querySelectorAll('.inquiry-indicator').forEach(el => {
            hasItems ? el.classList.add('show') : el.classList.remove('show');
        });
    }

    function saveFormData() {
        localStorage.setItem(INQUIRY_FORM_STORAGE_KEY, JSON.stringify(formDataToObject(new FormData(formEl), ["inquiry_form[_token]", "inquiry_form[gdpr]"])));
        setInquiryIndicator();
    }

    function bindForm(stepInfo) {
        formEl = inquiryFormContentWrappertEl.querySelector('form');
        formEl.dataset.currentStep = stepInfo.currentStep;
        formEl.dataset.maxStep = stepInfo.maxStep;
        formEl.addEventListener('submit', onSubmit);
        formEl.querySelector("#inquiry_form_back").addEventListener('click', onGoBack);
        formEl.querySelectorAll('.nav-link').forEach(el => {
            el.addEventListener('click', onGoToStep);
        })
        formEl.querySelectorAll("input, textarea, select").forEach(el => {
            el.addEventListener("change", saveFormData);
        });

        // Reinitialize quantity inputs after form is loaded via AJAX
        reinitQuantityInputs();
    }

    function getStepNumber(step) {
        return parseInt(step.match(/^step_(\d+)$/)[1]);
    }

    function changeStep(formEl, stepIncrement) {
        const {currentStepNumber, maxStepNumber} = getStepInfo(formEl);
        const nextCurrentStepNumber = currentStepNumber + 1 * stepIncrement;
        formEl.dataset.currentStep = 'step_' + nextCurrentStepNumber;
        formEl.dataset.maxStep = 'step_' + (maxStepNumber < nextCurrentStepNumber ? nextCurrentStepNumber : maxStepNumber);
    }

    function getStepInfo(formEl) {
        const currentStep = formEl?.dataset.currentStep ?? 'step_1';
        const maxStep = formEl?.dataset.maxStep ?? 'step_1';
        let currentStepNumber = getStepNumber(currentStep);
        let maxStepNumber = getStepNumber(maxStep);

        return {
            currentStep,
            maxStep,
            currentStepNumber,
            maxStepNumber
        }
    }

    /**
     * Načtení formuláře (při init i při odeslání)
     * 200 - načtení formuláře (init + kroky)
     * 201 - formulář odeslán
     * 422 - formulář nevalidní
     * @param initForm
     * @param skipStepIncrement - při načítaní formuláře nechceme měnit krok při prenacteni formulare
     * @returns {Promise<void>}
     */
    async function requestForm(initForm, skipStepIncrement = false) {
        let oldStepInfo = getStepInfo(formEl);

        const initFormData = !localStorage.getItem(INQUIRY_FORM_STORAGE_KEY) ? new FormData() : objectToFormData(JSON.parse(localStorage.getItem(INQUIRY_FORM_STORAGE_KEY) ?? "{}"));
        initFormData?.set("init_form", "true");

        try {
            const result = await fetch('/poptavka/formular/' + oldStepInfo.currentStep, {
                method: "POST",
                body: initForm ? initFormData : new FormData(formEl),
                headers: {"X-Requested-With": "XMLHttpRequest"}
            });

            // pokud je init formulare nebo je formulář nevalidní, načteme znovu obsah modalu
            if (result.status === 200 || result.status === 422) {
                inquiryFormContentWrappertEl.innerHTML = await result.text();
                bindForm(oldStepInfo);
            }

            localStorage.setItem(INQUIRY_FORM_STORAGE_KEY, JSON.stringify(formDataToObject(new FormData(formEl), ["inquiry_form[_token]", "inquiry_form[gdpr]"])));

            if (!initForm && !skipStepIncrement && result.status === 200) {
                changeStep(formEl, 1);
            }

            if (result.status === 201) {
                localStorage.removeItem(INQUIRY_FORM_STORAGE_KEY);
                window.location.href = '/poptavka/dokonceno';
                return;

            } else if (result.status === 422) {
                showAlert('#inquiryFormAlertPlaceholder', window.app.trans('inquiry.form.submit.not_valid'), 'danger')
            } else {
                if (!result.ok) showAlert('#inquiryFormAlertPlaceholder', window.app.trans('inquiry.form.submit.failed'), 'danger')
            }
            const {currentStep, currentStepNumber, maxStepNumber} = getStepInfo(formEl);

            const backBtnEl = formEl.querySelector("#inquiry_form_back");
            currentStepNumber <= 1 ? backBtnEl.classList.add('disabled') : backBtnEl.classList.remove('disabled');

            const submitBtnEl = formEl.querySelector("#inquiry_form_submit");
            submitBtnEl.textContent = currentStepNumber < INQUIRY_FORM_FINAL_STEP ? "Pokračovat" : "Dokončit poptávku";
            formEl.querySelectorAll('.nav-link').forEach(el => {
                el.dataset.step === currentStep ? el.classList.add('active') : el.classList.remove('active');
                const stepNumber = getStepNumber(el.dataset.step);
                maxStepNumber < stepNumber ? el.classList.add('disabled') : el.classList.remove('disabled');
            });

            formEl.querySelectorAll('.nav-section').forEach(el => {
                const {currentStep} = getStepInfo(formEl);
                el.dataset.step === currentStep ? el.classList.remove('d-none') : el.classList.add('d-none');
            });
        } catch (e) {
            console.error("Error while requesting inquiry form", e);
            showAlert('#inquiryFormAlertPlaceholder', window.app.trans('inquiry.form.submit.failed'), 'danger')
        }
    }
}

